import { ColumnAlias } from './column-alias.interface';

export const COLUMNS_ALIASES_STATE_NAME = 'columns-aliases';

export interface ColumnsAliasesState {
  columnsAliases: ColumnAlias[],
  loading: boolean;
  createMode: boolean;
}
